import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

const WIDGET_MIN_HEIGHT = "74px";
const ICON_SIZE = "42px";
const SHIMMER_WIDTH = "20px";
const ARROW_SIZE = "16px";

export const DineCashPoolingWidgetContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.cornerRadius.small,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    minHeight: WIDGET_MIN_HEIGHT,
    border: `3px solid ${theme.colors[theme.colorMode].background_Primary}`,
    background: `linear-gradient(73deg, ${theme.colors[theme.colorMode].positive_Sub} 7.3%, ${theme.colors[theme.colorMode].background_Primary} 44.39%)`,
    overflow: "hidden",
    position: "relative",
}));

export const WidgetLeftSection = styled.div(() => ({
    display: "flex",
    alignItems: "center",
}));

export const WidgetMiddleSection = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxxSmall,
    alignItems: "flex-start",
    maxWidth: "250px",
    position: "relative",
}));

export const WidgetRightSection = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginLeft: theme.spacing.xSmall,
    flex: 1,
}));

export const TitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    paddingLeft: theme.spacing.xSmall,
    gap: theme.spacing.xxSmall,
    width: "100%",
    position: "relative",
}));

export const TitleText = styled(Text)({
    width: "max-content",
});

export const SubtitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: theme.spacing.xSmall,
}));

export const IconContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: ICON_SIZE,
    height: ICON_SIZE,
}));

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Shimmer = styled.div({
    width: SHIMMER_WIDTH,
    height: "200%",
    transform: "rotate(35deg)",
    opacity: 0.2,
    background: "linear-gradient(270deg, rgba(27, 166, 114, 0.00) 0%, #1BA672 50%, rgba(27, 166, 114, 0.00) 100%);",
    position: "absolute",
    top: "-50%",
    left: "-100%",
    animation: "shimmerSweep 3s infinite",
    zIndex: 1,
    pointerEvents: "none",
    "@keyframes shimmerSweep": {
        "0%": {
            left: "-10%",
            opacity: 0.2,
        },
        "30%": {
            // opacity fades out
            opacity: 0.05,
        },
        "60%": {
            // sweep completes at 50% (1.5s / 3s)
            left: "110%",
            opacity: 0,
        },
        "60.01%": {
            // snap back invisibly
            left: "-10%",
            opacity: 0,
        },
        "100%": {
            // hold invisible for the remaining 50% (the 1.5s "pause")
            left: "-10%",
            opacity: 0,
        },
    },
});

export const ArrowContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: theme.spacing.xxSmall,
}));

export const Tag = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xxSmall}`,
    borderRadius: theme.cornerRadius.xxSmall,
    background: "linear-gradient(96deg, #EA3269 3.61%, #F15700 94.86%)",
}));

export const PooledAmount = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    marginLeft: theme.spacing.xSmall,
    gap: theme.spacing.xxxSmall,
}));

export const TooltipContent = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: `${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.small}`,
    backgroundColor: theme.colors[theme.colorMode].warning_Sub,
}));

export const Arrow = styled.div<{ left: number | null }>(({ theme, left }) => ({
    width: ARROW_SIZE,
    height: ARROW_SIZE,
    transform: "rotate(45deg) translateY(-50%)",
    position: "absolute",
    borderRadius: theme.cornerRadius.xxxSmall,
    top: "0",
    left: left ? `${left}px` : "80%",
    zIndex: 1,
    backgroundColor: theme.colors[theme.colorMode].warning_Sub,
}));

export const TooltipContainer = styled.div({
    position: "relative",
    width: "100%",
});

export const ContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
    padding: `${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.xxxSmall} `,
}));

export const Container = styled.div(({ theme }) => ({
    position: "relative",
    margin: `${theme.spacing.small} ${theme.spacing.medium}`,
    borderRadius: theme.cornerRadius.small,
    overflow: "hidden",
}));
